<nb-card class="dashboard-permission">
  <nb-card-header>
    <nb-icon (click)="closeDialog()" icon="close-outline"></nb-icon>
    دسترسی‌های داشبورد "{{asset?.assetName}}"
  </nb-card-header>
  <nb-card-body class="dashboard-permission-body" *ngIf="!loading">
    <div class="permission-info">
      <div class="body-alert">
        <morva-icons class="active-icon icon-18 ms-1" icon="info"></morva-icons>
        <div>
          مجوزهای اعطاشده به گروه کاربری براساس نقش هرکاربر تعیین خواهد شد.
        </div>
      </div>
      <a class="guidance" [href]="helpURL">
        <morva-icons icon="helpCircle" class="active-icon icon-16 ms-1"></morva-icons>
        راهنما
      </a>
    </div>

    <div class="dashboard-permission-table table-special">
      <!-- table header -->
      <div class="header">
        <div class="col-3">کاربر/گروه کاربری</div>
        <div class="col-2 default-access">تمپلیت دسترسی</div>
        <div class="header-icons col-7">
          <morva-icons nbTooltip="مشاهده" icon="eye" class="m-icon-1"></morva-icons>
          <morva-icons class="m-icon-1"
            nbTooltip="مشاهده نظرات"
            icon="chatBoxDots"
          ></morva-icons>
          <morva-icons class="m-icon-1"
            nbTooltip="اضافه کردن نظر"
            icon="addComment"
          ></morva-icons>
          <morva-icons class="m-icon-1"
            nbTooltip="حذف نظر"
            icon="removeComment"
          ></morva-icons>
          <morva-icons class="m-icon-1"
            nbTooltip="اضافه کردن نمودار"
            icon="addChart"
          ></morva-icons>
          <morva-icons nbTooltip="ویرایش" icon="pencil" class="m-icon-1"></morva-icons>
          <morva-icons class="m-icon-1"
                       nbTooltip="اشتراک‌گذاری داشبورد"
                       icon="share"
          ></morva-icons>
          <morva-icons nbTooltip="انتقال" icon="moveDown" class="m-icon-1"></morva-icons>
          <morva-icons class="m-icon-1"
            nbTooltip="فعال / غیرفعال کردن"
            icon="onAndOffToggle"
          ></morva-icons>
            <morva-icons class="m-icon-1"
                         nbTooltip="فیلتر کاربری"
                         icon="userFilter"
            ></morva-icons>
          <morva-icons class="m-icon-1"
            nbTooltip="دسترسی‌ها"
            icon="shield"
          ></morva-icons>
          <morva-icons nbTooltip="حذف" icon="trash" class="m-icon-1"></morva-icons>
        </div>
      </div>
      <hr />
      <!-- table-row -->
      <div *ngFor="let user of users; let userIndex = index">
        <div class="permission-row">
          <div class="row-title col-3 d-flex align-items-center">
            <morva-icons class="icon-18" icon="person"></morva-icons>
            <span class="me-2">
              {{ user?.firstName || user?.groupName }} {{ user?.lastName }}</span>
          </div>
          <div class="permission-container-dropdown col-2">
            <ng-select appendTo="body" class="permission-dropdown"
              [searchable]="false"
              [size]="'tiny'"
              [ngModel]="user?.isRole ? ( user?.roleId) : 'سفارشی'"
              (change)="changeRole($event,userIndex)"
            >
              <ng-option *ngFor="let role of defaultRoles" [value]="role?.id">{{
                role?.name
              }}</ng-option>
            </ng-select>
          </div>
          <div class="row-checkboxs col-5">
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('View')?.isChecked  && !user?.permissionsBlocked?.get('View')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('View')?.isChecked"
             (checkedChange)="changePermission($event,'View',userIndex)"
             ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('ViewComment')?.isChecked  && !user?.permissionsBlocked?.get('ViewComment')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('ViewComment')?.isChecked"
             (checkedChange)="changePermission($event,'ViewComment',userIndex)"
             ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('WriteComment')?.isChecked  && !user?.permissionsBlocked?.get('WriteComment')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('WriteComment')?.isChecked"
             (checkedChange)="changePermission($event,'WriteComment',userIndex)"
             ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('ResolveComment')?.isChecked  && !user?.permissionsBlocked?.get('ResolveComment')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('ResolveComment')?.isChecked"
             (checkedChange)="changePermission($event,'ResolveComment',userIndex)"
             ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('AddChart')?.isChecked  && !user?.permissionsBlocked?.get('AddChart')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('AddChart')?.isChecked"
             (checkedChange)="changePermission($event,'AddChart',userIndex)"
             ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('Edit')?.isChecked  && !user?.permissionsBlocked?.get('Edit')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('Edit')?.isChecked"
             (checkedChange)="changePermission($event,'Edit',userIndex)"
             ></nb-checkbox>
              <nb-checkbox class="m-icon-2"
                           [checked]="user?.permissionsSelected?.get('Share')?.isChecked  && !user?.permissionsBlocked?.get('Share')?.isChecked"
                           [disabled]="user?.permissionsBlocked?.get('Share')?.isChecked"
                           (checkedChange)="changePermission($event,'Share',userIndex)"
              ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('Movement')?.isChecked  && !user?.permissionsBlocked?.get('Movement')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('Movement')?.isChecked"
             (checkedChange)="changePermission($event,'Movement',userIndex)"
             ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('Activate/Deactivate')?.isChecked  && !user?.permissionsBlocked?.get('Activate/Deactivate')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('Activate/Deactivate')?.isChecked"
             (checkedChange)="changePermission($event,'Activate/Deactivate',userIndex)"
             ></nb-checkbox>
              <nb-checkbox class="m-icon-2"
                           [checked]="user?.permissionsSelected?.get('UserFilter')?.isChecked  && !user?.permissionsBlocked?.get('UserFilter')?.isChecked"
                           [disabled]="user?.permissionsBlocked?.get('UserFilter')?.isChecked"
                           (checkedChange)="changePermission($event,'UserFilter',userIndex)"
              ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('Permissions')?.isChecked  && !user?.permissionsBlocked?.get('Permissions')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('Permissions')?.isChecked"
             (checkedChange)="changePermission($event,'Permissions',userIndex)"
             ></nb-checkbox>
             <nb-checkbox class="m-icon-2"
             [checked]="user?.permissionsSelected?.get('Remove')?.isChecked  && !user?.permissionsBlocked?.get('Remove')?.isChecked"
             [disabled]="user?.permissionsBlocked?.get('Remove')?.isChecked"
             (checkedChange)="changePermission($event,'Remove',userIndex)"
             ></nb-checkbox>
          </div>
          <div class="cposition-absolute l-0 col-2 d-flex justify-content-end align-items-center">
            <nb-icon
              [matMenuTriggerFor]="menu"
              (click)="$event.stopPropagation()"
              class="more"
              icon="more-horizontal-outline">
            </nb-icon>

            <mat-menu class="menu-chart mat-elevation-z4" #menu="matMenu">
              <button mat-menu-item (click)="openDeleteDialog(user)">حذف</button>
            </mat-menu>
          </div>
        </div>
        <hr />
      </div>
    </div>
    <div *ngIf="!addUserMode" class="add-permission table-special">
      <div class="d-flex align-items-center" (click)="onAddUserClicK()">
        <morva-icons class="icon-18 active-icon" icon="addPerson"></morva-icons>
        <span>
        افزودن کاربر یا گروه کاربری
        </span>
      </div>
    </div>

    <form
      class="add-permission-user align-items-center"
      *ngIf="addUserMode"
      [formGroup]="profileForm"
      (ngSubmit)="onSaveUserClick()"
    >
      <div class="col-3">
        <input
          #searchKeyUser
          type="text"
          nbInput
          placeholder="کاربر/گروه موردنظر خود را وارد کنید..."
          formControlName="user"
          [nbAutocomplete]="auto"
        />
        <nb-autocomplete #auto [handleDisplayFn]="viewHandle" (selectedChange)="changeUserRole($event)">

          <nb-option *ngFor="let user of newAccessUsers" [value]="user">
            <morva-icons class="icon-18" icon="person"></morva-icons>
            <span class="me-3">{{ user?.firstName || user?.groupName }} {{ user?.lastName }}</span>
          </nb-option>

        </nb-autocomplete>
      </div>

      <div class="permission-container-dropdown col-2">
        <ng-select appendTo="body" class="permission-dropdown"
          [searchable]="false"
          [size]="'tiny'"
          formControlName="userRole"
          [placeholder]="profileForm.value.userRole"
          (change)="changeDefaultAccess($event)"
        >
          <ng-option *ngFor="let role of defaultRoles" [value]="role?.id">{{
            role?.name
          }}</ng-option>
        </ng-select>
      </div>


      <div class="row-checkboxs col-7">
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('View')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('View')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('View')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'View')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('ViewComment')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('ViewComment')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('ViewComment')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'ViewComment')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('WriteComment')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('WriteComment')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('WriteComment')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'WriteComment')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('ResolveComment')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('ResolveComment')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('ResolveComment')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'ResolveComment')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('AddChart')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('AddChart')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('AddChart')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'AddChart')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('Edit')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('Edit')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('Edit')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'Edit')"
         ></nb-checkbox>
          <nb-checkbox class="m-icon-2"
                       [checked]="permissionsTemp.get('Share')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('Share')?.isChecked"
                       [disabled]="profileForm.value.user?.permissionsBlocked?.get('Share')?.isChecked || !profileForm.value.user?.id"
                       (checkedChange)="changeAccess($event,'Share')"
          ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('Movement')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('Movement')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('Movement')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'Movement')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('Activate/Deactivate')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('Activate/Deactivate')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('Activate/Deactivate')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'Activate/Deactivate')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('UserFilter')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('UserFilter')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('UserFilter')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'UserFilter')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('Permissions')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('Permissions')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('Permissions')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'Permissions')"
         ></nb-checkbox>
         <nb-checkbox class="m-icon-2"
         [checked]="permissionsTemp.get('Remove')?.isChecked  && !profileForm.value.user?.permissionsBlocked?.get('Remove')?.isChecked"
         [disabled]="profileForm.value.user?.permissionsBlocked?.get('Remove')?.isChecked || !profileForm.value.user?.id"
         (checkedChange)="changeAccess($event,'Remove')"
         ></nb-checkbox>
      </div>

      <div class="add-user-buttons">
        <button
          nbButton
          type="submit"
          class="submit-button ms-1"
          [disabled]="profileForm.status === 'INVALID'"
        >
          ذخیره
        </button>
        <button nbButton class="cancel-button" (click)="closeAddUser()">
          انصراف
        </button>
      </div>
    </form>
    <morva-pagination *ngIf="totalPage > 1" [totalPage]="totalPage"
      [selectedPage]="pageNumber" (pageChange)="changePageNumber($event)"></morva-pagination>
    <div class="permisson-button">
      <button
        class="cancel-button ms-3"
        nbButton
        size="large"
        (click)="closeDialog()"
      >
        بستن
      </button>

    </div>
  </nb-card-body>
  <nb-card-body class="dashboard-permission-body" *ngIf="loading">
    <div class="dashboard-permission-table table-special">
      <div class="permission-row pb-3">
        <div class="col-3">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '132px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
        <div class="col-9">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '630px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
      </div>
      <div class="permission-row">
        <div class="col-3">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '132px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
        <div class="col-9">
          <ngx-skeleton-loader class="w-100" appearance="line" [theme]="{width: '630px', height: '20px', 'margin-bottom': 0, 'margin-top': '7px', 'background-color':'#EFEFEF'}"></ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </nb-card-body>
</nb-card>
